import { useAppSelector } from 'hooks/useAppStore';
import { hasPermission, hasAnyRole } from 'shared/permissions/permissionMatrix';
import type { Permission } from 'types';
import type { Role } from 'constants/roles';

export function usePermission(permission: Permission): boolean {
  const roles = useAppSelector((state) => state.auth.user?.roles ?? []);
  return hasPermission(roles, permission);
}

export function useHasRole(allowedRoles: Role[]): boolean {
  const roles = useAppSelector((state) => state.auth.user?.roles ?? []);
  return hasAnyRole(roles, allowedRoles);
}

export function useCurrentRoles(): string[] {
  return useAppSelector((state) => state.auth.user?.roles ?? []);
}
